import React from 'react';
import Theme from '../../theme';

interface SVGProps {
  height?: string;
  fill?: string;
  width?: string;
}

const BatteryIcon: React.FunctionComponent<SVGProps> = ({
  height = '14px',
  fill = Theme.colors.dark.hexCode,
  width = '20px',
}: SVGProps) => {
  const viewBox = `0 0 ${width} ${height}`.replace(/px/g, '');

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Access</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Dashboard_-1-Copy-12"
          transform="translate(-34.000000, -277.000000)"
          fill={fill}
          fillRule="nonzero"
        >
          <g id="Group-24" transform="translate(24.660000, 264.674192)">
            <path
              d="M28.35,21.06 C28.797363,21.06 29.16,21.422637 29.16,21.87 L29.16,21.87 L29.16,23.49 C29.16,24.832089 28.072089,25.92 26.73,25.92 L26.73,25.92 L25.11,25.92 C24.662637,25.92 24.3,25.557363 24.3,25.11 C24.3,24.662637 24.662637,24.3 25.11,24.3 L25.11,24.3 L26.73,24.3 C27.177363,24.3 27.54,23.937363 27.54,23.49 L27.54,23.49 L27.54,21.87 C27.54,21.422637 27.902637,21.06 28.35,21.06 Z M10.53,21.06 C10.9773468,21.06 11.34,21.422637 11.34,21.87 L11.34,23.49 C11.34,23.937363 11.7026532,24.3 12.15,24.3 L13.77,24.3 C14.2173468,24.3 14.58,24.662637 14.58,25.11 C14.58,25.557363 14.2173468,25.92 13.77,25.92 L12.15,25.92 C10.8079515,25.92 9.72,24.832089 9.72,23.49 L9.72,21.87 C9.72,21.422637 10.0826491,21.06 10.53,21.06 Z M13.77,16.2 C14.2173468,16.2 14.58,16.5626532 14.58,17.01 L14.58,17.01 L14.58,21.87 C14.58,22.317363 14.2173468,22.68 13.77,22.68 C13.3226532,22.68 12.96,22.317363 12.96,21.87 L12.96,21.87 L12.96,17.01 C12.96,16.5626532 13.3226532,16.2 13.77,16.2 Z M25.11,16.2 C25.557363,16.2 25.92,16.5626532 25.92,17.01 L25.92,17.01 L25.92,21.87 C25.92,22.317363 25.557363,22.68 25.11,22.68 L25.11,22.68 L24.3,22.68 C23.852637,22.68 23.49,22.317363 23.49,21.87 L23.49,21.87 L23.49,17.01 C23.49,16.5626532 23.852637,16.2 24.3,16.2 L24.3,16.2 Z M17.82,16.2 C18.267363,16.2 18.63,16.5626532 18.63,17.01 L18.63,21.87 C18.63,22.317363 18.267363,22.68 17.82,22.68 L17.01,22.68 C16.5626451,22.68 16.2,22.317363 16.2,21.87 L16.2,17.01 C16.2,16.5626532 16.5626532,16.2 17.01,16.2 L17.82,16.2 Z M21.06,16.2 C21.507363,16.2 21.87,16.5626532 21.87,17.01 L21.87,17.01 L21.87,21.87 C21.87,22.317363 21.507363,22.68 21.06,22.68 C20.612637,22.68 20.25,22.317363 20.25,21.87 L20.25,21.87 L20.25,17.01 C20.25,16.5626532 20.612637,16.2 21.06,16.2 Z M13.77,12.96 C14.2173468,12.96 14.58,13.3226532 14.58,13.77 C14.58,14.2173468 14.2173468,14.58 13.77,14.58 L13.77,14.58 L12.15,14.58 C11.7026532,14.58 11.34,14.9426532 11.34,15.39 L11.34,15.39 L11.34,17.01 C11.34,17.4573468 10.9773468,17.82 10.53,17.82 C10.0826491,17.82 9.72,17.4573468 9.72,17.01 L9.72,17.01 L9.72,15.39 C9.72,14.0479515 10.8079515,12.96 12.15,12.96 L12.15,12.96 Z M26.73,12.96 C28.072089,12.96 29.16,14.0479515 29.16,15.39 L29.16,15.39 L29.16,17.01 C29.16,17.4573468 28.797363,17.82 28.35,17.82 C27.902637,17.82 27.54,17.4573468 27.54,17.01 L27.54,17.01 L27.54,15.39 C27.54,14.9426532 27.177363,14.58 26.73,14.58 L26.73,14.58 L25.11,14.58 C24.662637,14.58 24.3,14.2173468 24.3,13.77 C24.3,13.3226532 24.662637,12.96 25.11,12.96 L25.11,12.96 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BatteryIcon;
